import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {API} from '@chekin/api';

type Props = {
  id?: string;
};
export const useFetchMultiPayment = ({id}: Props) => {
  return useQuery({
    queryKey: [QUERY_CACHE_KEYS.multiPayment, id],
    queryFn: () => API.payments.getMultiPayment(id ?? ''),
    enabled: Boolean(id),
    gcTime: 1000 * 60 * 5,
    staleTime: 1000 * 60 * 5,
  });
};
